<template lang="pug">
  #DeliveryStateCards
    b-row(cols="1" cols-md="6")
      b-col.mb-2
        state-count-card(
          stateName="En Transito"
          color="var(--status-in-transit)"
          icon="local_shipping"
          :stateCount="countStatus['in-transit']"
        )
      b-col.mb-2
        state-count-card(
          stateName="Entregados"
          color="var(--status-approved)"
          icon="inventory"
          :stateCount="countStatus['approved']"
        )
      b-col.mb-2
        state-count-card(
          stateName="Pendientes"
          color="var(--status-partial)"
          icon="block"
          :stateCount="countStatus['partial']"
        )
      b-col.mb-2
        state-count-card(
          stateName="Reprogramados"
          color="var(--status-rescheduled)"
          icon="event"
          :stateCount="countStatus['rescheduled']"
        )
      b-col.mb-2
        state-count-card(
          stateName="Rechazados"
          color="var(--status-rejected)"
          icon="thumb_down"
          :stateCount="countStatus['rejected']"
        )
      b-col.mb-2
        state-count-card(
          stateName="Cancelados"
          color="var(--status-cancelled)"
          icon="delete"
          :stateCount="countStatus['cancelled']"
        )
</template>

<script>
import StateCountCard from '../UI/StateCountCard'
import { mapGetters } from 'vuex'

export default {
  components: {
    StateCountCard
  },
  computed: {
    ...mapGetters(['countStatus'])
  }
}
</script>
